import { useState } from "react";


export const usePaginationCard = () => {

    const [delta, setDelta] = useState(10);
    const [cur, setCur] = useState(1);

    return {
        delta, setDelta, cur, setCur
    };
};
